import API from "../services/api";
import EventOptionGroup from "../models/event/EventOptionGroup";

export default class EventOptionGroupRepository {
    static all = (event, language = null) => API.get('/event/option-group/all?event=' + event).then(response => response.data.option_groups.map(group => EventOptionGroup.fromJson(group, language)));
    static get = (id, event, language = null) => API.get('/event/option-group/details/' + id + '?event=' + event).then(response => EventOptionGroup.fromJson(response.data.option_group, language));

    static create = (data) => API.post('/event/option-group/create', data);
    static update = (data) => API.post('/event/option-group/update', data);
    static updateOrder = (event, tree) => API.post('/event/option-group/update/order', { event: event, tree: tree });
    static delete = (data) => API.delete('/event/option-group/delete?id=' + data.id + '&event=' + data.event);
}
